module.exports = __webpack_public_path__ + "img/info.4067c89e.svg";